var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle",attrs:{"id":"circle"},on:{"touchstart":_vm.start}},[_c('img',{style:('left:' + _vm.left + 'px;top:' + _vm.top + 'px'),attrs:{"src":require("../assets/mobile/btn.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }